var React = require('react');

function Shape2 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0 41.5172C0 18.5888 20.1605 0 45.0327 0H150.967C175.84 0 196 18.5888 196 41.5172C196 64.4458 175.84 83.0345 150.967 83.0345H45.0327C20.1605 83.0169 0 64.4282 0 41.5172Z"}));
}

Shape2.defaultProps = {"width":"196","height":"84","viewBox":"0 0 196 84","fill":"none"};

module.exports = Shape2;

Shape2.default = Shape2;
